import React from 'react';

import appContent from '@/services/content/appContent.typed';
import AutoDeliveryDcxDeliveryWindowLabel from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxDeliveryWindowLabel';
import AutoDeliveryDcxNextDeliveryDateRangeTitle from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxNextDeliveryDateRangeTitle';
import AutoDeliveryDcxDeliveryStepper from '@/views/AutoDeliveryDcx/AutoDeliveryDcxDeliveryStepper/AutoDeliveryDcxDeliveryStepper';

import AutoDeliveryDcxSection from './AutoDeliveryDcxSection';

interface AutoDeliveryDcxNextDeliveryDetailsProps {
    className?: string;
    status: string;
    statusUpdateReason: string | null;
    orderStatus: string | null;
    minDeliveryDaysCount: number;
    maxDeliveryDaysCount: number;
    nextDeliveryDate: string | null;
    maxNextDeliveryDate: string | null;
    extraSection?: React.ReactNode;
}

const AutoDeliveryDcxNextDeliveryDetails = ({
    className,
    status,
    orderStatus,
    statusUpdateReason,
    minDeliveryDaysCount,
    maxDeliveryDaysCount,
    nextDeliveryDate,
    maxNextDeliveryDate,
    extraSection,
}: AutoDeliveryDcxNextDeliveryDetailsProps) => {
    const {nextDeliveryRangeTitle} = appContent.getAutoDeliveryContent()?.extendedDetailsContent || {};

    return (
        <AutoDeliveryDcxSection className={className}>
            <AutoDeliveryDcxDeliveryWindowLabel
                label={nextDeliveryRangeTitle}
                minDeliveryDaysCount={minDeliveryDaysCount}
                maxDeliveryDaysCount={maxDeliveryDaysCount}
                className='text-14 font-bold leading-[20px] tracking-02 text-primary-dark-85 md:text-16 md:leading-15'
            />
            <AutoDeliveryDcxNextDeliveryDateRangeTitle
                nextDeliveryDate={nextDeliveryDate}
                maxNextDeliveryDate={maxNextDeliveryDate}
                className='mt-0 text-32 leading-[40px] md:mt-2 md:text-28 md:leading-[36px]'
            />
            <AutoDeliveryDcxDeliveryStepper
                status={status}
                statusUpdateReason={statusUpdateReason}
                orderStatus={orderStatus}
                className='mt-8 text-16 ml:pb-3'
            />
            {extraSection}
        </AutoDeliveryDcxSection>
    );
};

export default AutoDeliveryDcxNextDeliveryDetails;
